<template>
  <b-sidebar
    :visible.sync="visible"
    class="vacation-request-sidebar b-sidebar-light"
    right
    shadow
    backdrop
    width="430px"
    no-header
    @hidden="$emit('update:visible', false)"
  >
    <div class="sidebar-custom-header d-flex justify-content-between align-items-center px-1 py-1 border-bottom">
      <h5 class="font-weight-bolder m-0">
        Solicitar
      </h5>
      <button
          type="button"
          class="close"
          @click="$emit('update:visible', false)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="sidebar-content">
      <validation-observer ref="createVacation">
        <b-form
          @submit.prevent="handleSubmit"
          @keydown.enter="handleSubmit"
        >
          <b-form-group v-if="role == 'admin'" label-for="for-other-user" class="mb-2">
            <b-form-checkbox
              v-model="isForOtherUser"
              class="d-inline-block"
              switch
              inline
            >
              Solicitar para otro usuario
            </b-form-checkbox>
          </b-form-group>
          <b-form-group v-if="role == 'admin' && isForOtherUser" label="Usuario" label-for="user-select" class="mb-2">
            <validation-provider
              v-slot="{ errors }"
              name="Usuario"
              rules="required"
            >
                <BaseSelect
                  v-model="user_select"
                  :searchable="true"
                  :clearable="true"
                  :multiple="false"
                  :httpBody="{
                    client_id: currentClient.id,
                    roles: ['operario'],
                  }"
                  :resource="'/users'"
                />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group v-if="role == 'admin' && isForOtherUser && user_select" label="Notificación" label-for="notification" class="mb-2">
            <b-form-checkbox
                v-model="send_notification"
                :value="true"
                :unchecked-value="false"
                class="d-inline-block"
                switch
                inline
            >
              ¿Enviar notificación al usuario asignado?
            </b-form-checkbox>
          </b-form-group>
          <b-form-group label="Motivo" label-for="reason" class="mb-2">
            <validation-provider
              v-slot="{ errors }"
              name="Motivo"
              rules="required"
            >
              <v-select
                v-model="form.reason"
                :options="reasonOptions"
                label="text"
                :reduce="option => option.value"
                placeholder="Selecciona motivo"
                :clearable="false"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <div v-if="selectedRequestType && selectedRequestType.allowed_time" class="allowed-time-box mt-1">
              <div class="allowed-time-content">
                <strong>{{ selectedRequestType.allowed_time }}</strong>
                <br>
                <span class="allowed-time-label">permitido</span>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            label="Fecha inicio"
            label-for="start-date"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Fecha inicio"
              rules="required"
            >
              <b-form-datepicker
                id="start-date"
                v-model="form.startDate"
                required
                locale="es"
                :month-names="['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']"
                :day-names="['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']"
                label-no-date-selected="No hay fecha seleccionada"
                label-current-month="Mes actual"
                label-next-month="Mes siguiente"
                label-prev-month="Mes anterior"
                label-today="Hoy"
                label-reset="Restablecer"
                nav-button-variant="outline-primary"
                start-weekday="1"
                hide-header
                calendar-width="100%"
              />
              <span
                v-if="errors[0]"
                class="text-danger"
              >{{ errors[0] }}</span>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Fecha fin"
            label-for="end-date"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Fecha fin"
              rules="required|afterStart"
              :data="{ startDate: form.startDate }"
            >
              <b-form-datepicker
                id="end-date"
                ref="endDatePicker"
                v-model="form.endDate"
                required
                :min="form.startDate"
                locale="es"
                :month-names="['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']"
                :day-names="['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']"
                label-no-date-selected="No hay fecha seleccionada"
                label-current-month="Mes actual"
                label-next-month="Mes siguiente"
                label-prev-month="Mes anterior"
                label-today="Hoy"
                label-reset="Restablecer"
                nav-button-variant="outline-primary"
                start-weekday="1"
                hide-header
                calendar-width="100%"
              />
              <span
                v-if="errors[0]"
                class="text-danger"
              >{{ errors[0] }}</span>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Observaciones"
            label-for="observations"
          >
            <b-form-textarea
              id="observations"
              v-model="form.observations"
              rows="3"
              placeholder="Añadir comentario (no introduzcas datos personales)"
            />
          </b-form-group>
          <b-form-group label="Documentos" label-for="document-file">
            <FileDropzone ref="files" :files="files" label="Cargar documento" max-files="3" />
          </b-form-group>
          <b-row class="mt-2">
            <b-col cols="6">
              <b-button
                  variant="outline-primary"
                  block
                  @click="$emit('update:visible', false)"
              >
                Cancelar
              </b-button>
            </b-col>
            <b-col cols="6">
              <b-button
                  type="submit"
                  variant="primary"
                  block
              >
                Solicitar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </b-sidebar>
</template>

<script>
import {
  BFormDatepicker,
  BSidebar,
  BFormGroup,
  BButton,
  BFormTextarea,
  BForm,
  BRow,
  BCol,
  BFormCheckbox,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import FileDropzone from '@/components/elements/FileDropzone/FileDropzone.vue'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  components: {
    BFormCheckbox,
    BCol,
    BRow,
    FileDropzone,
    BFormTextarea,
    BFormDatepicker,
    BSidebar,
    BFormGroup,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BaseSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      requestTypes: 'absences/getRequestTypes',
      currentClient: 'clients/getCurrentClient',
      role: 'auth/getRole',
    }),
    reasonOptions() {
      return [
        { value: '', text: 'Selecciona motivo' },
        ...this.requestTypes.map(t => ({ value: t.id, text: t.name, allowed_time: t.allowed_time })),
      ]
    },
    selectedRequestType() {
      return this.requestTypes.find(t => t.id === this.form.reason) || null
    },
  },
  data() {
    return {
      form: {
        reason: '',
        startDate: '',
        endDate: '',
        observations: '',
      },
      isForOtherUser: false,
      user_select: '',
      send_notification: false,
      files: [],
    }
  },
  watch: {
    isForOtherUser(newVal) {
      if (!newVal) {
        this.user_select = ''
        this.send_notification = false
      }
    },
  },
  methods: {
    ...mapActions({
      create: 'absences/create',
      createdirect: 'absences/createdirect',
      getRequestTypes: 'absences/getRequestTypes',
    }),
    handleSubmit() {
      this.$refs.createVacation.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            if (this.isForOtherUser && this.user_select) {
              this.createdirect({ absence: formData })
            } else {
              this.create({ absence: formData })
            }
          }
        }
      })
    },
    createFormData() {
      const formData = this.$refs.files.getFormData()
      formData.append('type_id', this.form.reason)
      formData.append('start_date', this.form.startDate)
      formData.append('end_date', this.form.endDate)

      if (this.isForOtherUser && this.user_select) {
        formData.append('user_id', this.user_select.id)
        formData.append('send_notification', String(this.send_notification))
      } else {
        formData.append('user_id', this.$store.getters['auth/getUser'].id)
      }

      formData.append('comment', this.form.observations)
      // Calcular requested_days
      if (this.form.startDate && this.form.endDate) {
        const start = new Date(this.form.startDate)
        const end = new Date(this.form.endDate)
        const diffTime = end.getTime() - start.getTime()
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1
        formData.append('requested_days', diffDays)
      } else {
        formData.append('requested_days', 0)
      }
      return formData
    },
  },
  created() {
    this.getRequestTypes()
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style scoped>
.allowed-time-box {
  background: #f6f6f6;
  border-radius: 8px;
  padding: 0.7em 1em;
  color: #2a3a4a;
  font-size: 1em;
  border: 1px solid #e0e6ed;
  margin-top: 0.5em;
}
.allowed-time-content {
  text-align: center;
}
.allowed-time-label {
  font-size: 0.85em;
  color: #6c7a89;
}
.sidebar-content {
  padding: 2rem 1.5rem 1.5rem 1.5rem;
}
.b-form-group {
  margin-bottom: 1.3rem;
}
.b-form-datepicker {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  background: #fff;
}
.b-form-textarea {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.b-button {
  min-width: 110px;
  border-radius: 8px;
  font-weight: 500;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.d-flex.justify-content-end {
  gap: 0.5rem;
  margin-top: 1.5rem;
}
.b-form-group label {
  font-weight: 500;
  color: #3a3a3a;
  margin-bottom: 0.3rem;
}
.text-danger {
  font-size: 0.92em;
}
</style>
